import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pdl-10 pdr-10 mt-30" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-md-center w-100 flex-md-row flex-column" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Manage Local Representative Accounts", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "small striped toggle no-underline vertical-align-start mt-30" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Login Email Address"),
    /*#__PURE__*/_createElementVNode("th", null, "First Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Days to Expiration"),
    /*#__PURE__*/_createElementVNode("th", null, "Designation"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "plan-modal fs-xs iatse-icon-noun-reset" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "plan-modal iatse-icon-deactivate-user" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, " / ", -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " / ", -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "plan-modal iatse-icon-noun-reset-password" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "expiration-date" }, "Not Activated", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      errors: $setup.errors,
      success: $setup.success
    }, null, 8, ["errors", "success"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "btn btn-primary plan-modal sm-mt-10",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openModal('local-representative-pin', 'Request PIN For Local Representative', 'plan-upload plan-card-info plan-profile-update')))
        }, " Request PIN for Local Representative ")
      ]),
      ($setup.loading)
        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _hoisted_6,
              ($setup.localStore.representative.members?.length > 0 || $setup.localStore.representative.pendingMembers?.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.localStore.representative.members, (member) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: member.UserID,
                        class: "large"
                      }, [
                        _createElementVNode("td", null, _toDisplayString(member.Email), 1),
                        _createElementVNode("td", null, _toDisplayString(member.FirstName), 1),
                        _createElementVNode("td", null, _toDisplayString(member.LastName), 1),
                        _createElementVNode("td", null, _toDisplayString(member.DaysToAccountExpiration), 1),
                        _createElementVNode("td", null, _toDisplayString(member.Designation), 1),
                        _createElementVNode("td", null, _toDisplayString(member.Phone), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_8, [
                            (!member.IsActive)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  onClick: ($event: any) => ($setup.handleChangeActive(member.UserID)),
                                  class: "tooltip-wrapper",
                                  "data-tooltip": "Activate User"
                                }, _hoisted_11, 8, _hoisted_9))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  onClick: ($event: any) => ($setup.handleChangeActive(member.UserID)),
                                  class: "tooltip-wrapper",
                                  "data-tooltip": "Deactivate User"
                                }, _hoisted_14, 8, _hoisted_12)),
                            _hoisted_15,
                            _createElementVNode("span", {
                              onClick: ($event: any) => ($setup.resetPin(member.UserID)),
                              class: "tooltip-wrapper",
                              "data-tooltip": "Reset PIN"
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(['plan-modal', 'iatse-icon-reset', { 'icon-green': member.DaysToAccountExpiration === 0 }])
                              }, null, 2)
                            ], 8, _hoisted_16),
                            _hoisted_17,
                            _createElementVNode("span", {
                              onClick: ($event: any) => ($setup.resetPassword(member.UserID)),
                              class: "tooltip-wrapper",
                              "data-tooltip": "Reset Password"
                            }, _hoisted_20, 8, _hoisted_18)
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.localStore.representative.pendingMembers, (pendingMember) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: pendingMember.UILocalRequestID,
                        class: "large"
                      }, [
                        _createElementVNode("td", null, _toDisplayString(pendingMember.Email), 1),
                        _createElementVNode("td", null, _toDisplayString(pendingMember.FirstName), 1),
                        _createElementVNode("td", null, _toDisplayString(pendingMember.LastName), 1),
                        _createElementVNode("td", null, _toDisplayString(pendingMember.DaysToAccountExpiration), 1),
                        _createElementVNode("td", null, _toDisplayString(pendingMember.Designation), 1),
                        _createElementVNode("td", null, _toDisplayString(pendingMember.Phone), 1),
                        _hoisted_21
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
    ])
  ], 64))
}